import { render, staticRenderFns } from "./InsertZimu.vue?vue&type=template&id=fc9fb0ec&scoped=true"
import script from "./InsertZimu.vue?vue&type=script&lang=js"
export * from "./InsertZimu.vue?vue&type=script&lang=js"
import style0 from "./InsertZimu.vue?vue&type=style&index=0&id=fc9fb0ec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9fb0ec",
  null
  
)

export default component.exports